var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappChannel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 169,
    viewBox: "0 0 168 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_387)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.5 24.5597C135.752 16.7469 126.532 10.5527 116.373 6.33671C106.214 2.1207 95.3193 -0.0330948 84.322 0.00038439C38.22 0.00038439 0.7 37.5645 0.7 83.7401C0.699108 98.4353 4.5618 112.872 11.9 125.599L0 169L44.352 157.348C56.6101 164.037 70.3467 167.547 84.308 167.557C100.859 167.56 117.039 162.651 130.802 153.449C144.565 144.247 155.293 131.167 161.629 115.862C167.965 100.556 169.624 83.7143 166.398 67.465C163.171 51.2158 155.202 36.2895 143.5 24.5737V24.5597ZM84.35 153.452C71.8863 153.446 59.6539 150.082 48.937 143.712L46.389 142.192L20.069 149.094L27.069 123.413L25.424 120.779C16.3023 106.281 12.8409 88.9261 15.702 72.0339C18.5631 55.1417 27.5458 39.8985 40.9315 29.2206C54.3172 18.5428 71.166 13.18 88.2544 14.1584C105.343 15.1367 121.471 22.3875 133.553 34.5235C143.285 44.267 149.912 56.68 152.597 70.1932C155.281 83.7064 153.903 97.713 148.636 110.442C143.369 123.171 134.45 134.052 123.006 141.707C111.562 149.363 98.1072 153.45 84.343 153.452H84.35Z",
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.546 117.365C134.72 99.1731 134.79 69.7488 116.703 51.644C98.616 33.5391 69.2209 33.6095 51.0471 51.8012C32.8734 69.9929 32.803 99.4171 50.89 117.522C68.977 135.627 98.3721 135.557 116.546 117.365Z",
    stroke: "#25D366",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeDasharray: "50 28.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappChannel);
export default __webpack_public_path__ + "static/media/whatsappChannel.67d3e04c1092928e842379f9ff813711.svg";
export { ForwardRef as ReactComponent };